import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { doCreateAdminUser, doGetAdminUser, doGetAdminUsers, doRemoveAdminUser, doUpdateAdminUser } from './thunk';

const isActionWithPending = (action) => {
  return action.type && action.type.startsWith('AdminUsers/') && action.type.endsWith('/pending');
};

const isActionWithFulfilled = (action) => {
  return action.type && action.type.startsWith('AdminUsers/') && action.type.endsWith('/fulfilled');
};

const isActionWithFailed = (action) => {
  return action.type && action.type.startsWith('AdminUsers/') && action.type.endsWith('/rejected');
};

const adminUsersAdapter = createEntityAdapter({
  selectId: (item) => item.id,
});

const adminUserSlice = createSlice({
  name: 'adminUser',
  initialState: {
    action: null,
    isFetching: false,
    currentUser: null,
    status: 'idle',
    metadata: {},
    entities: [],
    ids: [],
    item: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(doGetAdminUsers.pending, (state) => {
      state.action = 'getall';
      state.status = 'loading';
    });
    builder.addCase(doGetAdminUsers.fulfilled, (state, action) => {
      const { users, pagination } = action.payload;
      state.status = 'succeeded';
      state.metadata = pagination;
      adminUsersAdapter.setAll(state, users);
    });
    builder.addCase(doGetAdminUsers.rejected, (state) => {
      state.status = 'failed';
      adminUsersAdapter.setAll(state, []);
    });
    builder.addCase(doGetAdminUser.pending, (state) => {
      state.action = 'getOne';
      state.status = 'loading';
    });
    builder.addCase(doGetAdminUser.fulfilled, (state, action) => {
      state.status = 'succeeded';
      if (action.payload) {
        state.currentUser = action.payload;
      }
    });
    builder.addCase(doGetAdminUser.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doCreateAdminUser.pending, (state) => {
      state.action = 'create';
      state.status = 'loading';
    });
    builder.addCase(doCreateAdminUser.fulfilled, (state) => {
      state.status = 'succeeded';
    });
    builder.addCase(doCreateAdminUser.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doUpdateAdminUser.pending, (state) => {
      state.action = 'update';
      state.status = 'loading';
    });
    builder.addCase(doUpdateAdminUser.fulfilled, (state) => {
      state.status = 'succeeded';
    });
    builder.addCase(doUpdateAdminUser.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addCase(doRemoveAdminUser.pending, (state) => {
      state.action = 'remove';
      state.status = 'loading';
    });
    builder.addCase(doRemoveAdminUser.fulfilled, (state) => {
      state.status = 'succeeded';
    });
    builder.addCase(doRemoveAdminUser.rejected, (state) => {
      state.status = 'failed';
    });
    builder.addMatcher(isActionWithPending, (state) => {
      state.isFetching = true;
      state.message = null;
    });
    builder.addMatcher(isActionWithFulfilled, (state) => {
      state.isFetching = false;
    });
    builder.addMatcher(isActionWithFailed, (state) => {
      state.isFetching = false;
      state.message = null;
    });
  },
});

export const {
  selectAll: selectAllAdminUsers,
  selectById: selectAdminUserById,
  selectIds: selectAdminUserIds,
} = adminUsersAdapter.getSelectors((state) => state.adminUser);
const { reducer: AdminUserReducer } = adminUserSlice;
export default AdminUserReducer;
